var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('el-alert',{class:{
      'has-tips': !!_vm.$slots.tips,
    },attrs:{"type":"info","show-icon":"","closable":false},scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('div',{staticClass:"suoming",class:{
          'has-singleline': !!_vm.$slots.singleline || !!_vm.$slots.tips,
        }},[_vm._t("titleName",function(){return [_vm._v(_vm._s(!!_vm.$slots.tips ? "温馨提示：" : "说明："))]}),_c('span',{staticClass:"singleline"},[_vm._t("singleline"),_vm._t("tips")],2)],2),_c('div',{staticClass:"multiline"},[_vm._t("multiline")],2)]},proxy:true}],null,true)})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }